import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd';

@Directive({
    selector: '[zxImagePreview]'
})
export class ImagePreviewDirective {
    private screenWidth: number = window.innerWidth;
    private screenHeight: number = window.innerHeight;
    private naturalWidth: number;
    private naturalHeight: number;
    private element: any;
    constructor(
        private elementRef: ElementRef,
        private modalService: NzModalService
    ) {
        this.elementRef.nativeElement.style.cursor = "pointer";
        this.elementRef.nativeElement.addEventListener('click', ()=>{
            this.element = elementRef.nativeElement;
            this.naturalWidth = this.element.naturalWidth;
            this.naturalHeight = this.element.naturalHeight;
            this.openPreview();
        });
    }


    @Input('src') src : string;
    @Input('nzPreviewWidth') width : number = 700;

    
    openPreview() {
        let imgElement: any;
        let modalWidth: any;
        imgElement = `<img src="${this.src}" style="max-width:${this.screenWidth - 200}px;max-height:${this.screenHeight - 200}px;" width="100%">`;
        if ((this.naturalWidth >= this.screenWidth && this.naturalHeight <= this.screenHeight)) {
            modalWidth = this.screenWidth - 200 + 48;
        } else if ((this.naturalWidth <= this.screenWidth && this.naturalHeight >= this.screenHeight)) {
            modalWidth = (this.screenHeight - 200) / this.naturalHeight * this.naturalWidth + 48;
        } else if(this.naturalWidth >= this.screenWidth && this.naturalHeight >= this.screenHeight) {
            if (this.naturalWidth / this.screenWidth >= this.naturalHeight / this.screenHeight) {
                modalWidth = this.screenWidth - 200 + 48;
            } else {
                modalWidth = (this.screenHeight - 200) / this.naturalHeight * this.naturalWidth + 48;
            }
        } else {
            imgElement = `<img src="${this.src}" style="max-width:${this.screenWidth - 200}px;max-height:${this.screenHeight - 200}px;" height="500px">`;
            modalWidth = this.naturalWidth / (this.naturalHeight / 500) + 48;
        }
        if(this.src == null) return; 
        this.modalService.create({
            nzContent: imgElement,
            nzFooter: null,
            nzWidth: modalWidth,
        });
    }
}
